import { USER_TYPE } from "types/User";
import { nativeEnum, object, string, TypeOf } from "zod";

const passwordVerification = string({ required_error: "Contraseña obligatoria" }).min(8, "Contraseña inválida, debe tener mas de 8 carácteres" )

export const VerifyFormValidation = object({
  password: passwordVerification,
  passwordRepetition: passwordVerification,
})
.refine(data => data.password === data.passwordRepetition, { message: "Las contraseñas deben coincidir", path: ["passwordRepetition"] });

export type IVerifyFormValidation = TypeOf<typeof VerifyFormValidation>;